<template>
  <!--    upcoming, eligible, past-->
  <div class="q-pa-md" id="Schemes">
    <q-dialog persistent transition-hide="scale" transition-show="scale" v-model="verifyOtpDialog">
      <q-card>
        <q-bar class="bg-teal text-white">
          <div>Verify OTP</div>
          <q-space/>
          <q-btn @click="otp=''" dense flat icon="close" v-close-popup>
            <q-tooltip>Close</q-tooltip>
          </q-btn>
        </q-bar>

        <q-card-section>
          Please enter OTP send on mobile number {{ user.mobile }}
        </q-card-section>

        <q-card-section>
          <div class="row q-col-gutter-md">
            <div class="col-xs-4">
              <q-input label="Enter OTP" v-model="otp"></q-input>
            </div>
            <div class="col-xs-8 text-center q-mt-md">
              <q-btn :disable="verifyOtpDisabled" @click="verifyOtp" class="q-mr-lg" color="accent" size="12px">VERIFY
                OTP
              </q-btn>
              <q-btn @click="joinScheme(null)" color="primary" size="12px">RESEND OTP</q-btn>
            </div>
          </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="Cancel" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog position="right" v-model="viewSchemeDialog">
      <SchemeDetail :id="currentSchemeId" @onCloseViewScheme="viewSchemeDialog=false"></SchemeDetail>
    </q-dialog>
    <q-tabs align="left" class="text-primary" style="padding-left: 16px;padding-right: 16px; position: relative; top: -20px" v-model="tab">
      <q-tab :label="'Joined ('+jointSchemes.length+')'" class="text-green" name="joint"></q-tab>
      <q-tab :label="'Eligible ('+eligibleSchemes.length+')'" class="text-deep-orangec" name="eligible"></q-tab>
      <q-tab :label="'Upcoming ('+upcomingSchemes.length+')'" class="text-blue" name="upcoming"></q-tab>
      <q-tab :label="'Past ('+pastSchemes.length+')'" class="text-orange" name="past"></q-tab>
    </q-tabs>
    <q-separator style="position: relative; top: -22px;"></q-separator>

    <q-tab-panels animated v-model="tab">
      <q-tab-panel name="eligible">
        <div class="row " v-if="eligibleSchemes.length">

          <div class="col-4 q-pa-md " v-for="scheme in eligibleSchemes">
            <div class="card-bg">
              <q-img :src="constants.base_url+scheme.backgroundImage" @click="viewScheme(scheme)"
                     style="height: 100%;"></q-img>

              <div class="card-details p-3">
                <div class="position-relative" style="height: 100%;">
                  <div class="card-content">
                    <h5>{{ scheme.name }}</h5>
                  </div>

                  <div class="mt-3 w-100" style="align-items: center; ">
                    <div class="w-100 p-2">

                      <div class="pr-2">
                        <label class="bankLabel" style="color: #d4d4d4;">From</label>
                        <span class="d-block"
                              style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                            scheme.startTime|dateFilter
                          }}</span>
                      </div>
                      <div class="pt-3">
                        <label class="bankLabel" style="color: #d4d4d4;">To</label>
                        <span class="d-block"
                              style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                            scheme.endTime|dateFilter
                          }}</span>
                      </div>
                    </div>

                    <div class="s-action-buttons w-100">
                      <div class="d-flex">
                        <!--<div class="s-actions" @click="archiveScheme(scheme)">-->
                        <!--<img src="../../assets/box.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <div @click="joinScheme(scheme)" class="s-actions mx-2 px-3"
                             style="width: auto">
                          <p class="text-white">Join</p>
                        </div>
                        <div @click="viewScheme(scheme)" class="s-actions mx-2 px-3"
                             style="width: auto">
                          <p class="text-white">View details</p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-tab-panel>
      <q-tab-panel name="upcoming">
        <div class="row" v-if="upcomingSchemes.length">

          <div class="col-4 q-pa-md " v-for="scheme in upcomingSchemes">
            <div class="card-bg">
              <q-img :src="constants.base_url+scheme.backgroundImage" style="height: 100%;"></q-img>

              <div class="card-details p-3">
                <div class="position-relative" style="height: 100%;">
                  <div class="card-content">
                    <h5>{{ scheme.name }}</h5>
                  </div>

                  <div class="mt-3 w-100" style="align-items: center; ">
                    <div class="w-100 p-2">

                      <div class="pr-2">
                        <label class="bankLabel" style="color: #d4d4d4;">From</label>
                        <span class="d-block"
                              style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                            scheme.startTime|dateFilter
                          }}</span>
                      </div>
                      <div class="pt-3">
                        <label class="bankLabel" style="color: #d4d4d4;">To</label>
                        <span class="d-block"
                              style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                            scheme.endTime|dateFilter
                          }}</span>
                      </div>
                    </div>

                    <div class="s-action-buttons w-100">
                      <div class="d-flex justify-content-between">
                        <!--<div class="s-actions" @click="archiveScheme(scheme)">-->
                        <!--<img src="../../assets/box.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <!--                                            <div class="s-actions" @click="joinScheme(scheme)">-->
                        <!--                                            <img alt="" style="margin-top: 13px;" class="d-block mx-auto" src="../../assets/link.png">-->
                        <!--                                              </div>-->
                        <div @click="viewScheme(scheme)" class="s-actions mx-2 px-3"
                             style="width: auto">
                          <p class="text-white">View details</p>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!--<div class="text-subtitle2 my-5">-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.startTime|dateFilter}}</p>-->
                  <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.endTime|dateFilter}}</p>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
            <!--<div class="s-img">-->
            <!--<div class="s-card">-->
            <!--<q-img :ratio="1" :src="constants.base_url+scheme.backgroundImage"-->
            <!--@click="viewScheme(scheme)">-->
            <!--</q-img>-->


            <!--<div @click="viewScheme(scheme)" class="s-card-text mt-4 w-100" style="height: 100%">-->
            <!--<div class="w-100 p-3 ">-->
            <!--<div class="text-h6 mx-auto w-100">-->
            <!--<h5 style="color: #fff; text-align: center; text-transform: unset">-->
            <!--{{scheme.name}}</h5>-->
            <!--</div>-->

            <!--<div>-->
            <!--<img alt="" class="d-block mx-auto mt-3" src="../../assets/zigzag.png">-->
            <!--</div>-->

            <!--<div class="text-subtitle2 my-5 text-center">-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.startTime|dateFilter}}</p>-->
            <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.endTime|dateFilter}}</p>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="s-action-section">-->
            <!--&lt;!&ndash;<div class="s-actions" @click="archiveScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-del">&ndash;&gt;-->
            <!--&lt;!&ndash;archive&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--<div @click="joinScheme(scheme)" class="s-actions">-->
            <!--<div style="margin-top: 12px;">-->
            <!--<img alt="" class="d-block mx-auto my-auto" src="../../assets/link.png">-->
            <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash;<div class="s-actions" @click="viewScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-viw">&ndash;&gt;-->
            <!--&lt;!&ndash;remove_red_eye&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>

        </div>
        <div v-else>
          <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
          <h6 class="text-center">No data available</h6>
        </div>
      </q-tab-panel>
      <q-tab-panel name="past">
        <div class="row " v-if="pastSchemes.length">

          <div class="col-4 q-pa-md " v-for="scheme in pastSchemes">
            <div class="card-bg">
              <q-img :src="constants.base_url+scheme.backgroundImage" style="height: 100%;"></q-img>

              <div class="card-details p-3">
                <div class="position-relative" style="height: 100%;">
                  <div class="card-content">
                    <h5>{{ scheme.name }}</h5>
                  </div>

                  <div class="mt-3 w-100" style="align-items: center; ">
                    <div class="w-100 p-2 d-flex justify-content-between">
                      <div>
                        <div class="pr-2">
                          <label class="bankLabel" style="color: #d4d4d4;">From</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                              scheme.startTime|dateFilter
                            }}</span>
                        </div>
                        <div class="pt-3">
                          <label class="bankLabel" style="color: #d4d4d4;">To</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                              scheme.endTime|dateFilter
                            }}</span>
                        </div>
                      </div>
                      <div>
                        <div class="pt-0">
                          <label class="bankLabel" style="color: #d4d4d4;">Total Eligible
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;"
                                v-if="scheme.isHerirachyScheme">{{
                              calculateEligiblePoints(scheme.SchemeEnrollments[0], true)
                            }}</span>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;"
                                v-else>{{ calculateEligiblePoints(scheme.SchemeEnrollments[0], false) }}</span>
                        </div>
                        <div class="pt-3">
                          <label class="bankLabel" style="color: #d4d4d4;">Redeemable
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{
                              calculateClosingPoints(scheme.SchemeEnrollments[0], scheme)
                            }}</span>
                        </div>
                        <div class="pt-2">
                          <label class="bankLabel" style="color: #d4d4d4;">Total
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{
                              calculateTotalPoints(scheme.SchemeEnrollments[0], scheme)
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="s-action-buttons w-100">
                      <div class="d-flex justify-content-between ">
                        <!--<div class="s-actions" @click="archiveScheme(scheme)">-->
                        <!--<img src="../../assets/box.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <!--<div class="s-actions" @click="editScheme(scheme)">-->
                        <!--<img src="../../assets/edit.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <div @click="viewScheme(scheme)" class="s-actions mx-2 px-3"
                             style="width: auto">
                          <p class="text-white">View details</p>
                        </div>
                        <div class="s-actions px-3" style="width: auto;margin: 0 !important;" title='Special Scheme'
                             v-if="scheme.isSpecialScheme">
                          <q-icon name="grade" class="text-yellow"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--<div class="text-subtitle2 my-5">-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.startTime|dateFilter}}</p>-->
                  <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.endTime|dateFilter}}</p>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
            <!--<div class="s-img">-->
            <!--<div class="s-card">-->
            <!--<q-img :ratio="1" :src="constants.base_url+scheme.backgroundImage"-->
            <!--@click="viewScheme(scheme)">-->
            <!--</q-img>-->

            <!--<div @click="viewScheme(scheme)" class="s-card-text mt-4 w-100" style="height: 100%">-->
            <!--<div class="w-100 p-3 ">-->
            <!--<div class="text-h6 mx-auto w-100">-->
            <!--<h5 style="color: #fff; text-align: center; text-transform: unset">-->
            <!--{{scheme.name}}</h5>-->
            <!--</div>-->

            <!--<div>-->
            <!--<img alt="" class="d-block mx-auto mt-3" src="../../assets/zigzag.png">-->
            <!--</div>-->

            <!--<div class="text-subtitle2 my-5 text-center">-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.startTime|dateFilter}}</p>-->
            <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.endTime|dateFilter}}</p>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash;<div class="s-action-section">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="archiveScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-del">&ndash;&gt;-->
            <!--&lt;!&ndash;archive&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="editScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-edt">&ndash;&gt;-->
            <!--&lt;!&ndash;edit&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="viewScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-viw">&ndash;&gt;-->
            <!--&lt;!&ndash;remove_red_eye&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
        <div v-else>
          <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
          <h6 class="text-center">No data available</h6>
        </div>
      </q-tab-panel>
      <q-tab-panel name="joint">
        <div class="row " v-if="jointSchemes.length">

          <div class="col-4 q-pa-md " v-for="scheme in jointSchemes">
            <div class="card-bg">
              <q-img :src="constants.base_url+scheme.backgroundImage" style="height: 100%;"></q-img>

              <div class="card-details p-3">
                <div class="position-relative" style="height: 100%;">
                  <div class="card-content">
                    <h5>{{ scheme.name }}</h5>
                  </div>

                  <div class="mt-3 w-100" style="align-items: center; ">
                    <div class="w-100 p-2 d-flex justify-content-between">
                      <div>
                        <div class="pr-2">
                          <label class="bankLabel" style="color: #d4d4d4;">From</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                              scheme.startTime|dateFilter
                            }}</span>
                        </div>
                        <div class="pt-3">
                          <label class="bankLabel" style="color: #d4d4d4;">To</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{
                              scheme.endTime|dateFilter
                            }}</span>
                        </div>
                      </div>
                      <div>
                        <div class="pt-0">
                          <label class="bankLabel" style="color: #d4d4d4;">Total Eligible
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;"
                                v-if="scheme.isHerirachyScheme">{{
                              calculateEligiblePoints(scheme.SchemeEnrollments[0], true)
                            }}</span>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;"
                                v-else>{{ calculateEligiblePoints(scheme.SchemeEnrollments[0], false) }}</span>
                        </div>
                        <div class="pt-3">
                          <label class="bankLabel" style="color: #d4d4d4;">Redeemable
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{
                              calculateClosingPoints(scheme.SchemeEnrollments[0], scheme)
                            }}</span>
                        </div>
                        <div class="pt-3">
                          <label class="bankLabel" style="color: #d4d4d4;">Total
                            Points</label>
                          <span class="d-block"
                                style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{
                              calculateTotalPoints(scheme.SchemeEnrollments[0], scheme)
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="s-action-buttons w-100">
                      <div class="d-flex justify-content-between ">
                        <!--<div class="s-actions" @click="archiveScheme(scheme)">-->
                        <!--<img src="../../assets/box.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <!--<div class="s-actions" @click="editScheme(scheme)">-->
                        <!--<img src="../../assets/edit.png" style="margin-top: 13px; width: 22px" alt="">-->
                        <!--</div>-->
                        <div @click="viewScheme(scheme)" class="s-actions mx-2 px-3"
                             style="width: auto">
                          <p class="text-white">View details</p>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!--<div class="text-subtitle2 my-5">-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.startTime|dateFilter}}</p>-->
                  <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
                  <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">{{scheme.endTime|dateFilter}}</p>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
            <!--<div class="s-img">-->
            <!--<div class="s-card">-->
            <!--<q-img :ratio="1" :src="constants.base_url+scheme.backgroundImage"-->
            <!--@click="viewScheme(scheme)">-->
            <!--</q-img>-->

            <!--<div @click="viewScheme(scheme)" class="s-card-text mt-4 w-100" style="height: 100%">-->
            <!--<div class="w-100 p-3 ">-->
            <!--<div class="text-h6 mx-auto w-100">-->
            <!--<h5 style="color: #fff; text-align: center; text-transform: unset">-->
            <!--{{scheme.name}}</h5>-->
            <!--</div>-->

            <!--<div>-->
            <!--<img alt="" class="d-block mx-auto mt-3" src="../../assets/zigzag.png">-->
            <!--</div>-->

            <!--<div class="text-subtitle2 my-5 text-center">-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.startTime|dateFilter}}</p>-->
            <!--<span class="d-block my-3" style="color: #fff; ">To</span>-->
            <!--<p style="font-size: 16px; color: #fff; letter-spacing: 5px">-->
            <!--{{scheme.endTime|dateFilter}}</p>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash;<div class="s-action-section">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="archiveScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-del">&ndash;&gt;-->
            <!--&lt;!&ndash;archive&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="editScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-edt">&ndash;&gt;-->
            <!--&lt;!&ndash;edit&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="s-actions" @click="viewScheme(scheme)">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="material-icons s-actions-viw">&ndash;&gt;-->
            <!--&lt;!&ndash;remove_red_eye&ndash;&gt;-->
            <!--&lt;!&ndash;</i>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
            <!--</div>-->
          </div>

        </div>
        <div v-else>
          <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
          <h6 class="text-center">No data available</h6>
        </div>
      </q-tab-panel>
    </q-tab-panels>

  </div>
</template>

<script>
import { GET_ALL_SCHEMES1, GET_PAST_SCHEMES, GET_UPCOMING_SCHEMES } from '../../graphql/queries/schemes'
import { SUBSCRIBE_ALL_SCHEMES1 } from '../../graphql/subscription/schemes'
import SchemeDetail from './SchemeDetail'
import Constants from '../../Constants/Constant'
import moment from 'moment'
import { NetworkCommunicator } from '../../plugins/NetworkResourceHandler'

Array.prototype.contains = function (obj) {
  var i = this.length
  while (i--) {
    if (this[i] == obj) {
      return true
    }
  }
  return false
}
export default {
  name: 'Schemes',
  components: { SchemeDetail },
  apollo: {
    Scheme: {
      query: GET_ALL_SCHEMES1,
      fetchPolicy: 'network-only',
      variables () {
        return {
          orgId: this.user.orgId,
          startTime: moment().format('YYYY-MM-DD'),
          endTime: moment().format('YYYY-MM-DD'),
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          let self = this
          let partnerType = self.user.organization.partnerType

          this.jointSchemes = []; this.eligibleSchemes = [];
          data.Scheme.forEach(s => {
            if(s.SchemeEnrollments[0]?.isVerified && s.criteria?.[0]?.value.contains(partnerType)) this.jointSchemes.push(s);
            else if (s.criteria?.[0]?.value.contains(partnerType)) this.eligibleSchemes.push(s)
            /* (!curnt.SchemeEnrollments.length || !curnt.SchemeEnrollments[0].isVerified) */
          })
        }
      },
      subscribeToMore: {
        variables () {
          return {
            orgId: this.user.orgId,
            startTime: moment().format('YYYY-MM-DD'),
            endTime: moment().format('YYYY-MM-DD'),
          }
        },
        document: SUBSCRIBE_ALL_SCHEMES1,
        updateQuery: function (previousQueryResult, { subscriptionData }) {
          let self = this
          let partnerType = self.user.organization.partnerType
          this.jointSchemes = []; this.eligibleSchemes = [];
          subscriptionData.data.Scheme.forEach(s => {
            if(s.SchemeEnrollments[0]?.isVerified && s.criteria?.[0]?.value.contains(partnerType)) this.jointSchemes.push(s);
            else if (s.criteria?.[0]?.value.contains(partnerType)) this.eligibleSchemes.push(s)
            /* (!curnt.SchemeEnrollments.length || !curnt.SchemeEnrollments[0].isVerified) */
          })
        },
      },
    },
    Upcoming_Schemes: {
      query: GET_UPCOMING_SCHEMES,
      fetchPolicy: 'network-only',
      variables () {return { startTime: moment().format('YYYY-MM-DD') }},
      result ({ data, loading }) {
        if (!loading) {
          let self = this
          let partnerType = this.user.organization.partnerType
          data.Upcoming_Schemes.forEach(function (curnt) {
            if (curnt.criteria && curnt.criteria.length && curnt.criteria[0].value.contains(partnerType)) {
              self.upcomingSchemes.push(curnt)
            }
          })
        }
      },
    },
    Past_Schemes: {
      query: GET_PAST_SCHEMES,
      fetchPolicy: 'network-only',
      variables () {
        return {
          endTime: moment().format('YYYY-MM-DD'),
          orgId: this.user.orgId,
          partnerTypeId: this.user.organization.partnerType,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          let self = this
          let partnerType = this.user.organization.partnerType
          data.Past_Schemes.forEach(function (curnt) {
            if (curnt.isSpecialScheme ||
                (curnt.criteria && curnt.criteria.length && curnt.criteria[0].value.contains(partnerType))) {
              self.pastSchemes.push(curnt)
            }
          })
        }
      },
    },

  },
  data () {
    return {
      constants: Constants,
      tab: 'joint',
      eligibleSchemes: [],
      upcomingSchemes: [],
      jointSchemes: [],
      otp: '',
      otpId: '',
      verifyOtpDialog: false,
      user: JSON.parse(localStorage.getItem('user')),
      pastSchemes: [],
      viewSchemeDialog: false,
      currentSchemeId: '',
      verifyOtpDisabled: false,
    }
  },
  methods: {
    viewScheme (scheme) {
      this.currentSchemeId = scheme.id
      this.viewSchemeDialog = true
    },
    async joinScheme (scheme) {
      this.$q.dialog({
        title: 'Join Scheme',
        message: `<h6>If you want to join scheme, please contact your preferred distributor.</h6>`,
        html: true,
        style: 'width: 445px',
        cancel: false,
        persistent: true,
      }).onOk(() => {})
     /* let self = this
      this.otp = ''
      console.log(scheme, scheme?1:2)
      let response = await NetworkCommunicator('POST', `${Constants.api_url}sendOtpForSchemeJoin`,
          false,
          { userId: self.user.id, orgId: self.user.orgId, schemeId: scheme ? scheme.id : this.currentSchemeId },
          {})
      if (response.flag) {
        self.currentSchemeId = scheme ? scheme.id : self.currentSchemeId
        self.verifyOtpDialog = true
        self.otpId = response.data.id
        self.verifyOtpDisabled = false
        self.$q.notify('OTP sent successfully.')
      } else {
        alert(response.message)
      } */
    },
    async verifyOtp () {
      let self = this
      let response = await NetworkCommunicator('POST', `${Constants.api_url}verifySchemeJoinOTP`,
          false, { id: self.otpId, otp: self.otp }, {})
      if (response.flag) {
        self.$apollo.queries.Scheme.refetch()
        self.verifyOtpDialog = false
        self.otp = ''
      } else {
        if (response.code === 41) {
          this.$q.notify(response.message) //Invalid OTP
        } else if (response.code === 202) {
          this.$q.notify(response.message) //Maximum Try
          this.verifyOtpDisabled = true
          this.otp = ''
          this.otpId = ''
        } else {
          this.$q.notify(response.message)
        }
      }
    },
  },
  mounted () {
    if (this.$route.query.schemeId) {
      this.viewScheme({ id: this.$route.query.schemeId })
    }
  },
}
</script>

<style scoped>

</style>
